import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind CSS classes with proper conflict resolution.
 * Combines clsx for conditional classes with tailwind-merge for proper Tailwind precedence.
 *
 * This is the shadcn-convention location for the cn helper.
 * The legacy `src/utils.ts` re-exports from here for backward compatibility.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
